<template>
  <ActionsMenu v-bind="{ actionsBtnItems }" class="h-ml-3" />
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import ActionsMenu from '@/components/common/ActionsMenu';
import loadingMixin from '@/mixins/isLoading';
import matchHelper from '@/views/tournaments/management/brackets/mixins/matchHelper';
import roundHelper from '@/views/tournaments/management/brackets/mixins/roundHelper';

const delayTime = 200;

export default {
  name: 'BracketsActionsMenuTable',
  components: {
    ActionsMenu,
  },
  mixins: [loadingMixin, matchHelper, roundHelper],
  data() {
    return {
      tournamentID: this.$route.params.tournamentID,
      stageID: this.$route.params.stageID,
      blockID: this.$route.params.blockID,
      roundID: this.$route.params.roundID,
    };
  },
  computed: {
    actionsBtnItems() {
      return [
        {
          key: 'start-all',
          title: this.$t('_web_battles_start-all', 'Start All'),
          subtitle: this.$t(
            '_web_tournament_table-view_start-all-subtitle',
            'All selected matches will be started'
          ),
          icon: 'play-2',
          handler: this.confirmStartRound,
          disabled: false,
        },
        {
          key: 'finish-all',
          title: this.$t('_web_battles_finish-all', 'Finish All'),
          subtitle: this.$t(
            '_web_tournament-table-view_finish-all-subtitle',
            'All selected matches will be finished'
          ),
          icon: 'stop',
          handler: this.confirmFinishRound,
          disabled: false,
        },
        {
          title: this.$t(
            '_web_battles_chat-winners',
            'Chat with winners (captains)'
          ),
          handler: this.openChat.bind({
            conversationType: 'group_chat',
            targetGroup: 'Winners',
          }),
        },
        {
          title: this.$t(
            '_web_battles_chat-loosers',
            'Chat with eliminated (captains)'
          ),
          handler: this.openChat.bind({
            conversationType: 'group_chat',
            targetGroup: 'Losers',
          }),
        },
        {
          title: this.$t('_web_battles_chat-all', 'Chat with all'),
          handler: this.openChat.bind({
            conversationType: 'group_chat',
            targetGroup: 'All',
          }),
        },
        {
          title: this.$t(
            '_web_battles_channel-winners',
            'Channel with winners (captains)'
          ),
          handler: this.openChat.bind({
            conversationType: 'channel',
            targetGroup: 'Winners',
          }),
        },
        {
          title: this.$t(
            '_web_battles_channel-loosers',
            'Channel with eliminated (captains)'
          ),
          handler: this.openChat.bind({
            conversationType: 'channel',
            targetGroup: 'Losers',
          }),
        },
        {
          title: this.$t('_web_battles_channel-all', 'Channel with all'),
          handler: this.openChat.bind({
            conversationType: 'channel',
            targetGroup: 'All',
          }),
        },
        {
          key: 'reload',
          title: this.$t('_web_battles_reload', 'Reload'),
          subtitle: this.$t(
            '_web_tournament-block_reset-brackets-tooltip',
            'Press to clear all brackets in current stage'
          ),
          handler: () => {}, //this.onFilterChange,
          icon: 'reload',
          disabled: true,
        },
      ];
    },
  },
  methods: {
    ...mapMutations([
      'openConversationInSliderChatEditor',
      'toggleSliderChat',
      'sliderChatToggleLoader',
    ]),
    ...mapActions([
      'errorNotify',
      'openModal',
      'closeModal',
      'createTournamentConversationBySignature',
    ]),

    /**
     * Round confirm functions
     */
    confirmStartRound() {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_tournaments-tableview_start-round-message',
            'Now all battles in scheduled status will be started. Do you really want to proceed?'
          ),
        },
        events: {
          cancel: this.closeModal,
          confirm: this.onRoundStart.bind(null),
        },
      });
    },
    confirmFinishRound() {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_tournaments-tableview_finish-round-message',
            'Now all NOT COMPLETED matches will be closed. Matches  without results will be cancelled, for matches with results the system will define a winner'
          ),
        },
        events: {
          cancel: this.closeModal,
          confirm: this.onRoundFinish.bind(null),
        },
      });
    },
    onRoundStart() {
      this.startRound({
        roundID: this.currentRoundIndex,
      }).then(() => {
        this.$lodash.delay(this.onFilterChange, delayTime);
      });
    },
    onRoundFinish() {
      this.finishRound({
        roundID: this.currentRoundIndex,
      }).then(() => {
        this.$lodash.delay(this.onFilterChange, delayTime);
      });
    },
    openChat(signature) {
      this.setLoading();
      this.toggleSliderChat();
      this.sliderChatToggleLoader(true);
      const { conversationType, targetGroup } = signature;
      this.createTournamentConversationBySignature({
        tournamentId: this.tournamentID,
        round: this.roundID,
        conversationType,
        targetGroup,
        captainsOnly: true,
        visible: false,
        blockId: this.blockID,
      })
        .then(conversation =>
          this.openConversationInSliderChatEditor({
            conversation,
            predefinedTitle: '',
            predefinedSubtitle: '',
          })
        )
        .catch(this.errorNotify)
        .finally(() => {
          this.unsetLoading();
          this.sliderChatToggleLoader(false);
        });
    },
  },
};
</script>
